import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../styles/open-pages/lead-followups.css";
import {
  fetchAllLeadsData,
  fetchODMAllData,
  fetchUnassignedLeadsData,
} from "../../../redux/reducers/apiSlice";
import { fetchBTLLeadsData } from "../../../redux/prospect-reducers/prospectSlice";
import { fetchRecurringSubscriptionsData } from "../../../redux/plans-reducers/plansSlice";

const AllLeadsFollowupDetails = ({
  userInfoData,
  pageName,
  rowDataState,
  setRowDataState,
  prevFilters,
}) => {
  const dispatch = useDispatch();
  const {
    unassignedLeadsLoading,
    unassignedLeads,

    odmAllLoading,
    odmAllError,
    odmAll,
    allLeadsLoading,
    error,
    allLeads,
  } = useSelector((state) => state.api);
  const { leadsBTL, leadsBTLLoading, leadsBTLError } = useSelector(
    (state) => state.prospects
  );
  const {
    recurringSubscriptionLoading,
    recurringSubscriptionError,
    recurringSubscription,
  } = useSelector((state) => state.plans);

  const leadsListRef = useRef(null);
  const scrollAmount = 200;

  const iniFilters = {
    page: 1,
    limit: 10,
    added_to_lead:
      pageName === "odm" ||
      pageName === "btl" ||
      pageName === "recurring-999" ||
      pageName === "wati" ||
      pageName === "refferal" ||
      pageName === "ure"
        ? "1"
        : "",
    ...prevFilters,
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniDatas = {
    pagination: [],
    allLeads: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  function getAllLeads(filters) {
    if (pageName === "odm") {
      dispatch(
        fetchODMAllData({
          filters: filters,
          token: userInfoData?.token,
        })
      );
    } else if (pageName === "lms") {
      dispatch(
        fetchAllLeadsData({
          filters: filters,
          token: userInfoData?.token,
        })
      );
    } else if (pageName === "btl") {
      dispatch(
        fetchBTLLeadsData({
          filters: filters,
          token: userInfoData?.token,
        })
      );
    } else if (pageName === "recurring-999") {
      dispatch(
        fetchRecurringSubscriptionsData({
          filters: filters,
          token: userInfoData?.token,
        })
      );
    } else if (pageName === "wati") {
      dispatch(
        fetchUnassignedLeadsData({
          filters: filters,
          token: userInfoData?.token,
        })
      );
    }
  }

  const handleNext = () => {
    if (leadsListRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = leadsListRef.current;
      if (scrollLeft + clientWidth < scrollWidth) {
        leadsListRef.current.scrollBy({
          left: scrollAmount,
          behavior: "smooth",
        });
      } else {
        setFilters((prev) => ({ ...prev, page: prev.page + 1 }));
      }
    }
  };

  const handlePrev = () => {
    if (leadsListRef.current) {
      const { scrollLeft } = leadsListRef.current;
      if (scrollLeft > 0) {
        leadsListRef.current.scrollBy({
          left: -scrollAmount,
          behavior: "smooth",
        });
      } else if (filters.page > 1) {
        setFilters((prev) => ({ ...prev, page: prev.page - 1 }));
      }
    }
  };

  useEffect(() => {
    getAllLeads(filters);
  }, [filters]);

  useEffect(() => {
    if (pageName === "btl") {
      if (
        !leadsBTLLoading &&
        !leadsBTLError &&
        leadsBTL?.status &&
        leadsBTL?.data?.length > 0
      ) {
        setAllDatas((prevs) => ({
          ...prevs,
          allLeads: leadsBTL.data,
          pagination:
            leadsBTL?.pagination?.length > 0 ? leadsBTL.pagination : [],
        }));
      } else {
        setAllDatas(iniDatas);
      }
    }
  }, [leadsBTLLoading, leadsBTLError, leadsBTL]);

  useEffect(() => {
    if (pageName === "lms") {
      if (
        !allLeadsLoading &&
        !error &&
        allLeads?.status &&
        allLeads?.data?.length > 0
      ) {
        setAllDatas((prevs) => ({
          ...prevs,
          allLeads: allLeads.data,
          pagination:
            allLeads?.pagination?.length > 0 ? allLeads.pagination : [],
        }));
      } else {
        setAllDatas(iniDatas);
      }
    }
  }, [allLeadsLoading, error, allLeads]);

  useEffect(() => {
    if (pageName === "odm") {
      if (
        !odmAllLoading &&
        !odmAllError &&
        odmAll?.status &&
        odmAll?.data?.length > 0
      ) {
        setAllDatas((prevs) => ({
          ...prevs,
          allLeads: odmAll.data,
          pagination: odmAll?.pagination?.length > 0 ? odmAll.pagination : [],
        }));
      } else {
        setAllDatas(iniDatas);
      }
    }
  }, [odmAllLoading, odmAllError, odmAll]);

  useEffect(() => {
    if (pageName === "recurring-999") {
      if (
        !recurringSubscriptionLoading &&
        !recurringSubscriptionError &&
        recurringSubscription?.status &&
        recurringSubscription?.data?.length > 0
      ) {
        setAllDatas((prevs) => ({
          ...prevs,
          allLeads: recurringSubscription.data,
          pagination:
            recurringSubscription?.pagination?.length > 0
              ? recurringSubscription.pagination
              : [],
        }));
      } else {
        setAllDatas(iniDatas);
      }
    }
  }, [
    recurringSubscriptionLoading,
    recurringSubscriptionError,
    recurringSubscription,
  ]);

  useEffect(() => {
    if (pageName === "wati") {
      if (
        !unassignedLeadsLoading &&
        !error &&
        unassignedLeads?.status &&
        unassignedLeads?.data?.length > 0
      ) {
        setAllDatas((prevs) => ({
          ...prevs,
          allLeads: unassignedLeads.data,
          pagination:
            unassignedLeads?.pagination?.length > 0
              ? unassignedLeads.pagination
              : [],
        }));
      } else {
        setAllDatas(iniDatas);
      }
    }
  }, [unassignedLeadsLoading, error, unassignedLeads]);

  return (
    <div className="lead-followups-container">
      <div
        className={`pagination-buttons prev-btn ${
          filters.page === 1 ? "disabled-followup-btn" : "active-followup-btn"
        }`}>
        <button
          type="button"
          onClick={handlePrev}
          disabled={filters.page === 1}>
          ◀
        </button>
      </div>

      <div className="leads-list" ref={leadsListRef}>
        {allDatas.allLeads?.map((row, index) => (
          <div
            key={index}
            className={`lead-card ${
              rowDataState?.lead_id === row?.lead_id ? "active" : ""
            }`}
            onClick={() => setRowDataState(row)}>
            {pageName === "odm" ? row?.user_name || "NA" : row?.name || "NA"}
          </div>
        ))}
      </div>

      <div
        className={`pagination-buttons next-btn ${
          filters.page >= allDatas.pagination[0]?.pages
            ? "disabled-followup-btn"
            : "active-followup-btn"
        }`}>
        <button
          type="button"
          onClick={handleNext}
          disabled={filters.page >= allDatas.pagination[0]?.pages}>
          ▶
        </button>
      </div>
    </div>
  );
};

export default AllLeadsFollowupDetails;
